// extracted by mini-css-extract-plugin
module.exports = {"container":"loading-indicator_container__Uj1kd","dot":"loading-indicator_dot__TBihH","flashing":"loading-indicator_flashing__nUNDy"};